import { lazy } from 'react'

// Dashboard
export const Dashboard = lazy(() => import('../../pages/Dashboard'))

// Proclamation
export const Proclamation = lazy(() => import('../../pages/Proclamation/Proclamation'))
export const CreateProclamation = lazy(() => import('../../pages/Proclamation/CreateProclamation'))
export const UpdateProclamation = lazy(() => import('../../pages/Proclamation/UpdateProclamation'))

// SajayaInformationConfirm
export const SajayaInformationConfirm = lazy(() => import('../../pages/SajayaInformationConfirm/SajayaInformationConfirmByFile'))



// Proclamation/Pricing
export const Pricing = lazy(() => import('../../pages/Proclamation/Pricing/Pricing'))
export const CreatePricing = lazy(() => import('../../pages/Proclamation/Pricing/CreatePricing'))
export const UpdatePricing = lazy(() => import('../../pages/Proclamation/Pricing/UpdatePricing'))

// Proclamation/Pricing
export const Province = lazy(() => import('../../pages/BasicInfo/Province/Province'))
export const CreateProvince = lazy(() => import('../../pages/BasicInfo/Province/CreateProvince'))
export const UpdateProvince = lazy(() => import('../../pages/BasicInfo/Province/UpdateProvince'))

// Reports
export const PreReserveStatusReport = lazy(
  () => import('../../pages/Reports/PreReserveStatus/PreReserveStatusReport'),
)
export const PreReservePaidStatReport = lazy(
  () => import('../../pages/Reports/PreReservePaidStatReport/PreReservePaidStatReport'),
)
export const PreReservePaidStatDetailsReport = lazy(
  () =>
    import('../../pages/Reports/PreReservePaidStatDetailsReport/PreReservePaidStatDetailsReport'),
)
export const PreReserveNotPaidStatReport = lazy(
  () => import('../../pages/Reports/PreReserveNotPaidStatReport/PreReserveNotPaidStatReport'),
)
export const PreReserveNotPaidStatDetailsReport = lazy(
  () =>
    import(
      '../../pages/Reports/PreReserveNotPaidStatDetailsReport/PreReserveNotPaidStatDetailsReport'
    ),
)
export const PreReserveCanceledStatReport = lazy(
  () => import('../../pages/Reports/PreReserveCanceledStatReport/PreReserveCanceledStatReport'),
)
export const PreReserveCanceledStatDetailsReport = lazy(
  () =>
    import(
      '../../pages/Reports/PreReserveCanceledStatDetailsReport/PreReserveCanceledStatDetailsReport'
    ),
)
export const PreReserveStatReport = lazy(
  () => import('../../pages/Reports/PreReserveStatReport/PreReserveStatReport'),
)
export const PaymentReport = lazy(() => import('../../pages/Reports/PaymentResult/PaymentReport'))
export const SajayaRelationStateReport = lazy(
  () => import('../../pages/Reports/SajayaRelationStateport/SajayaRelationStatReport'),
)
export const CitiesPreReserveStateReport = lazy(
  () => import('../../pages/Reports/CitiesPreReserveStatReport/CitiesPreReserveStatReport'),
)
// PreReserve
export const PreReserve = lazy(() => import('../../pages/PreReserve/PreReserve'))
export const PreReserveTransferDate = lazy(
  () => import('../../pages/PreReserve/TransferDate/PreReserveTransferDate'),
)
export const MyPreReserve = lazy(() => import('../../pages/PreReserve/MyPreReserve/MyPreReserve'))
export const MyPayments = lazy(() => import('../../pages/PreReserve/MyPreReserve/MyPayments'))
export const CanclePreReserve = lazy(
  () => import('../../pages/PreReserve/MyPreReserve/CanclePreReserve'),
)
export const CompletePreReservation = lazy(
  () => import('../../pages/PreReserve/CompletePreReservation/CompletePreReservation'),
)
export const PaymentResult = lazy(
  () => import('../../pages/PreReserve/PaymentResult/PaymentResult'),
)
export const ReserveNewPreReserve = lazy(
  () => import('../../pages/PreReserve/ReserveNewPreReserve/ReserveNewPreReserve'),
)
export const AddNewPilgrim = lazy(
  () => import('../../pages/PreReserve/ReserveNewPreReserve/AddNewPilgrim'),
)
// Pilgrim Search
export const PilgrimSearch = lazy(() => import('../../pages/PilgrimSearch/PilgrimSearch'))
// RrsetPassword
export const ResetPassword = lazy(() => import('../../pages/Auth/ResetPassword'))
// My Info
export const MyInfo = lazy(() => import('../../pages/MyInfo/MyInfo'))
// NotFound
export const NotFound = lazy(() => import('../../pages/NotFound/NotFound'))
